import type { FaireBrandEntity } from "../../entity_types/brand";

// Anonymized stand-in for the p7_poor_roas archetype (real metrics, fake identity).
export const bAdvP7PoorRoas: FaireBrandEntity = {
  token: "b_adv_p7_poor_roas",
  type: "brand",
  name: "Orchard Lane Provisions",
  description: "Small-orchard cider and dried fruit snacks",
  location: "Wenatchee, WA",
  rating: 4.5,
  minimumOrderDollars: 100,
  tags: ["cider", "snacks", "orchard"],
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
